<div class="container">
  <h1>Admin Impersonation</h1>

  @if (!impersonateToken) {
    <form [formGroup]="signinForm" (ngSubmit)="submitSignin()">
      <label>Email</label>
      <input type="email" formControlName="email" placeholder="admin@example.com" />
      <label>Password</label>
      <input type="password" formControlName="password" placeholder="••••••••" />
      <button type="submit" [disabled]="signinForm.invalid || busy">Sign in as Admin</button>
      @if (error) {
        <div class="msg error">{{ error }}</div>
      }
      @if (info) {
        <div class="msg">{{ info }}</div>
      }
    </form>
  } @else {
    <form [formGroup]="impersonateForm" (ngSubmit)="submitImpersonate()">
      <label>Email or Merchant Slug</label>
      <input type="text" formControlName="email" placeholder="user@company.com or merchant-slug" />
      <button type="submit" [disabled]="impersonateForm.invalid || busy">Impersonate</button>
      @if (error) {
        <div class="msg error">{{ error }}</div>
      }
      @if (info) {
        <div class="msg">{{ info }}</div>
      }
    </form>
    <button
      type="button"
      class="secondary"
      (click)="goToAdminDashboard()"
      [disabled]="busy"
      >
      Go to Admin Dashboard
    </button>
  }

</div>
